// extracted by mini-css-extract-plugin
module.exports = {"label":"PunchupToggle_label__jx8os","input":"PunchupToggle_input__ax2EO","track":"PunchupToggle_track__etfmm","knob":"PunchupToggle_knob__anN3g"};